import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {VIDEO_BOOKMARK_API_URL} from '../../defines/protocol';
import {VideoLoader} from '../../interfaces/VideoLoader';
import {ApiService} from '../api/api.service';
import {VideoService} from './video.service';


@Injectable({
  providedIn: 'root'
})
export class VideoBookmarkService extends VideoService implements VideoLoader {

  constructor(
    protected override api: ApiService,
    ) {
    super(api);
    this.urlApi = VIDEO_BOOKMARK_API_URL
  }

  public sendBookmark(no: number, add: boolean = true): Observable<boolean> {
    const url = this.urlApi + no + '/';
    const obs = add ?
      this.api.Post(url, null) :
      this.api.Delete(url);

    return obs.pipe(
      map(data => {
        console.log('VideoBookmark::sendBookmark()', no, add, data);
        return data;
      }),
      // catchError((err, caught: Observable<boolean>) => {
      //   console.error('VideoBookmark::sendBookmark()', id, add, err);
      //   throwError(err);
      //   return caught;
      // })
    );
  }
}
